// @flow strict

/*
 * Redux Form validations
 */

export const required = (value: string | number | boolean) =>
  value ? undefined : 'Required';

export const phoneNumber = (value: string, previousValue: string) => {
  const onlyNums = value.replace(/[^\d +()-]/g, '');
  return onlyNums;
};
